
import React from 'react';
import { mdx } from '@mdx-js/react';


export const frontMatter = {
	id: 'rules',
	title: 'Rules'
};
export const contentTitle = undefined;
export const metadata = {
  "unversionedId": "api-reference/rules",
  "id": "api-reference/rules",
  "isDocsHomePage": false,
  "title": "Rules",
  "description": "Rules Overview",
  "source": "@site/docs/api-reference/rules.md",
  "sourceDirName": "api-reference",
  "slug": "/api-reference/rules",
  "permalink": "/docs/api-reference/rules",
  "tags": [],
  "version": "current",
  "frontMatter": {
    "id": "rules",
    "title": "Rules"
  },
  "sidebar": "docs",
  "previous": {
    "title": "Quotes",
    "permalink": "/docs/api-reference/quotes"
  },
  "next": {
    "title": "Overview",
    "permalink": "/docs/api-reference/events-and-actions"
  }
};


/* @jsxRuntime classic */
/* @jsx mdx */

export const toc = [{
  value: 'Rules Overview',
  id: 'rules-overview',
  children: []
}, {
  value: 'Action Types',
  id: 'action-types',
  children: [{
    value: 'Webhook',
    id: 'webhook',
    children: []
  }, {
    value: 'Email',
    id: 'email',
    children: []
  }, {
    value: 'Excel Rating Plan',
    id: 'excel-rating-plan',
    children: []
  }, {
    value: 'Carrier Direct API',
    id: 'carrier-direct-api',
    children: []
  }]
}];

const layoutProps = {
  toc
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h3 {...{
      "id": "rules-overview"
    }}>{`Rules Overview`}</h3>
    <p><strong parentName="p"><em parentName="strong">{`Rules are `}<inlineCode parentName="em">{`if-then`}</inlineCode>{` expressions that operate on provided data.`}</em></strong></p>
    <blockquote>
      <h4 parentName="blockquote" {...{
        "id": "what-data-is-provided-to-the-action-rules"
      }}>{`What data is provided to the action rules?`}</h4>
      <ul parentName="blockquote">
        <li parentName="ul">{`Client facts are always available to all rules (answers to question from any line)`}</li>
        <li parentName="ul">{`Data generated by specific actions, or their responses (i.e. Webhook, Rating, etc.), is available
to rules of those actions only.`}</li>
      </ul>
    </blockquote>
    <br />
    <p><strong parentName="p">{`Rule Example #1:`}</strong></p>
    <p>{`Assume we have a line with a trigger "Get Quote" that defines an Email action (sends email
every time quote is requested).  To reduce the volume of emails, we want to create a rule to only send email
when client has more than 3 locations and revenue over $100M.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`  if "client has more then 3 locations AND revenue greater then $100M"
then "run this action"
`}</code></pre>
    <p>{`As we mentioned earlier, client facts are always available to rules.  `}<strong parentName="p">{`Client fact is an answer to a specific question.`}</strong><br parentName="p"></br>{`
`}{`Client facts are provided to the as a map of `}<inlineCode parentName="p">{`key:value`}</inlineCode>{` pairs, where a key is a QID, and the value is the answer.`}</p>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`Where do I find QIDs for questions?`}</strong><br parentName="p"></br>{`
`}{`In the `}<em parentName="p">{`Intake Builder`}</em>{` of every line.  Top of each question shows canonicalId (visible to users) and
QID (visible internally).`}</p>
    </blockquote>
    <p>{`For example, let's consider these two questions on a line: `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Question`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`QID (Question Identifier)`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`How many locations does your business have?`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`business.location.count`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`What is your annual revenue?`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`total.annual.sales`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Here's how we would use these to construct the `}<strong parentName="p">{`condition`}</strong>{` portion of the rule - the `}<strong parentName="p">{`IF`}</strong>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`qid['business.location.count'] > 3 &&
qid['total.annual.sales'] >= 100000000
`}</code></pre>
    <h2 {...{
      "id": "action-types"
    }}>{`Action Types`}</h2>
    <h3 {...{
      "id": "webhook"
    }}>{`Webhook`}</h3>
    <p>{`Webhook action is one of the most versatile actions`}</p>
    <h3 {...{
      "id": "email"
    }}>{`Email`}</h3>
    <blockquote>
      <p parentName="blockquote">{`Documentation for this action coming soon`}</p>
    </blockquote>
    <h3 {...{
      "id": "excel-rating-plan"
    }}>{`Excel Rating Plan`}</h3>
    <blockquote>
      <p parentName="blockquote">{`Documentation for this action coming soon`}</p>
    </blockquote>
    <h3 {...{
      "id": "carrier-direct-api"
    }}>{`Carrier Direct API`}</h3>
    <blockquote>
      <p parentName="blockquote">{`Documentation for this action coming soon`}</p>
    </blockquote>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
